:host {
  display: block;
  position: relative;
}

.chart-container {
  position: relative;
}

.chartjs-tooltip {
  background: #ffffff;
  color: #333333;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(51, 51, 51, 0.05),
    0 5px 5px 0 rgba(51, 51, 51, 0.15);
  border: 1px solid #e7e6e6;
  opacity: 0;
  position: absolute;
  pointer-events: none;
  font-size: 11px;
  white-space: nowrap;
  z-index: 1;
}
